Content_loader = {
	init : function()
	{
		// Add global content loader structure.
		jQuery('body').append('<div id="oc-page-loader"><div class="load-icon-wrapper"></div></div>');
		//jQuery('#oc-page-loader').append('<div class="load-icon-wrapper"><div class="load-icon"></div></div>');
		//jQuery('#oc-page-loader').append('<div class="load-icon-wrapper"><div class="load-icon"></div></div>');
		jQuery('#oc-page-loader .load-icon-wrapper').append('<div class="ring"><div class="inner inner-1"></div><div class="inner inner-2"></div><div class="inner inner-3"></div><div class="inner inner-4"></div></div>');
	}
	,
	show : function()
	{
		//jQuery('#oc-page-loader').addClass('active');
		jQuery('body').addClass('oc-show-page-loader');
	}
	,
	hide : function()
	{
		//jQuery('#oc-page-loader').removeClass('active');
		jQuery('body').removeClass('oc-show-page-loader');
	}
};

Content_scroller = {
	init: function()
	{
		Content_scroller.init_ui();
	}
	,
	init_ui: function()
	{
		// Check for OnCloud scroll links.
		jQuery('.oc-scroll-link').each(function(pm_index){
			var scroll_link = jQuery(this);
			
			scroll_link.click(function(event){
				var link_id = scroll_link.attr('href');
				link_id = link_id.replace('#','');
				
				Content_scroller.scroll_page(link_id);
				
				event.preventDefault();
			});
		});
	}
	,
	scroll_page: function(pm_id = '', pm_offset = 50, pm_animate = true, pm_scroll_from_top = false)
	{
		// TODO: data attributes
		// data-offset
		// data-animate
		
		// Get the page.
		var page = jQuery('html, body');
		
		// Check if we want to scroll from the top of the page.
		if( pm_scroll_from_top )
		{
			//page.scrollTop(0);
		}
		
		// Offset by the header.
		var header_offset = jQuery('#header, .fl-page-header').height();
		
		// Move the page.
		var pos_y = jQuery('#' + pm_id).offset().top - (header_offset + pm_offset);
				
		if(pm_animate)
		{
			// Animate the page.
			page.animate({
				scrollTop: pos_y
			}, 500, function(){
				// Animation complete.
				//page.stop();				
				//page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
			});
		}
		else
		{
			page.scrollTop(pos_y);
		}
	}
}


jQuery(document).ready(function(jQuery){
	
	// Object Fit Polyfill for images.
	var $images_polyfill_list = jQuery('.hero img');
	if( $images_polyfill_list.size() > 0 )
	{
		objectFitImages( $images_polyfill_list );
	}
	
	
	// Initialise content loader.
	Content_loader.init();
	
	// Initialise content scroller.
	Content_scroller.init();
	
});